export default __webpack_public_path__ + "static/media/rotate-left.093dcbb1.svg";